export const GRAPHQL_ENDPOINT = 'https://api.edotw.com/graphql';
export const REST_ENDPOINT = 'https://api.edotw.com/rest';
